import React from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

const ClassItem = ({ classes }) => {
  let history = useHistory();

  function tConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[3] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  var bodyFormData = new FormData();
  const handleDelete = (key) => {
    const uname = JSON.parse(localStorage.getItem('uname'));
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const URL = `https://stucharge.bakersbrisk.com/api/liveclassapi?username=${uname}&id=${key}`;

    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateClass();
      } else if (result.isDenied) {
        Swal.fire('Class not deleted', '', 'info');
      }
    });

    async function updateClass() {
      bodyFormData.append('status', false);

      const requestOptions = {
        method: 'PUT',
        headers: { Authorization: AuthStr },
        body: bodyFormData,
      };
      fetch(URL, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          Swal.fire('Class deleted successfully!', '', 'success').then(
            (result) => {
              if (result.isConfirmed || !result.isConfirmed) {
                history.push('/home');
                history.push('/class');
              }
            }
          );
        })
        .catch((error) => {
          Swal.fire('Error deleted class', '', 'error');
        });
    }
  };

  return (
    <>
      {classes.map((item) => (
        <tr key={item.id}>
          <td data-label='Title' className='text-title'>
            {jsUcfirst(item.title)}
          </td>
          <td data-label='Date' className='text-pink'>
            {item.date}
          </td>
          <td data-label='Start'>{tConvert(item.start_time)}</td>
          <td data-label='End'>{tConvert(item.end_time)}</td>
          <td data-label='Update'>
            <a
              href={`/class/update/${item.id}`}
              className='bttn update'
              rel='noreferrer noopener'
            >
              Edit
            </a>
          </td>
          <td data-label='Delete'>
            <button
              onClick={() => handleDelete(item.id)}
              className='bttn delete'
              rel='noreferrer noopener'
              style={{ cursor: 'pointer' }}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
    </>
  );
};

export default ClassItem;
